import { createFileRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  cityId: z.uuid().optional(),
  isActive: z.coerce.boolean().optional(),
  kind: z.enum(['EVENTS', 'NEWS']).optional(),
});

export const Route = createFileRoute('/_authenticated/source-channels')({
  staticData: { breadcrumb: 'Источники' },
  validateSearch: searchSchema,
  component: () => <Outlet />,
});
